import { Image } from "@shopify/hydrogen";

export default function PaymentMethod() {
  return (
    <div className="md:container md:mx-auto xs:p-2 flex md:flex-wrap flex-col items-center pm-container">
      <div className="my-2 md:flex md:justify-center md:items-center md:flex-wrap xs:grid xs:grid-cols-3 xs:gap-4 items-center text-center ">
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/b9af27910be8f2aa673905b49b429662ea96c690-87x28.png"
              width="87px"
              height="28px"
              alt="Logo 97d09ac68bf0"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/f3e713e391d96de3fc82a9aef63303e1f228e714-55x55.png"
              width="55px"
              height="55px"
              alt="Logo 58014e47fa0b"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/d78a8a48c748d9ef72222c5cdb7abf5bc1738a00-50x50.png"
              width="50px"
              height="50px"
              alt="Logo 047ba96430ca"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/072c3d1d2c84b99c94b6f751fceafe3c7e8fae19-160x39.png"
              width="160px"
              height="39px"
              alt="Logo 74c853381fc1"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/06164a2e5c91aa45f6f14c2ca349c2e386303823-145x38.png"
              width="145px"
              height="38px"
              alt="Logo 4683e2dd6f1a"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/32d08e548ec1f994505d77b77f0d3f11f239d2a9-130x31.png"
              width="130px"
              height="31px"
              alt="Logo 0e66c0039ba5"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/5fcb4991ecf56fadc2d68a4ba3165ec673d55bf4-87x48.png"
              width="87px"
              height="48px"
              alt="Logo bad23e9a8709"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/9244bf8005f0033d2241467f30673fcdcdc0fd16-80x60.png"
              width="80px"
              height="60px"
              alt="Logo abea751ceb3e"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <div className="mx-2">
          <div to="#" className=" cursor-default pm-image">
            <Image
              className="rounded-lg mx-auto"
              src="https://cdn.sanity.io/images/3bk3u1ri/production/8737c81f78cfd3c142541bd85e82cab9ffbddfe0-130x61.png"
              width="130px"
              height="61px"
              alt="Logo 84e26ec78699"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
